<!--
  Two host elements, mirroring elements/button/button.twig:
  the reference renders <a> when a url is given, and <button> otherwise.
  Exactly one branch is instantiated, so the projected content is safe.
-->
<ng-template #inner>
  <span *ngIf="loading" class="fi-button__spinner" aria-hidden="true"></span>
  <img *ngIf="!loading && iconBefore" class="fi-button__icon" [src]="iconBefore" alt="">

  <!--
    Icon slot, mirroring the reference's {% include "@elements/icon" %}. Use it for
    icons that are not a URL - a mat-icon ligature or an inline svg - by marking
    the element with fiButtonIcon. Decorative by definition: the accessible name
    comes from the projected label.
  -->
  <span class="fi-button__icon" aria-hidden="true"><ng-content select="[fiButtonIcon]"></ng-content></span>

  <span class="fi-button__label" [class.fi-button__label--hidden]="iconOnly"><ng-content></ng-content></span>

  <img *ngIf="iconAfter" class="fi-button__icon" [src]="iconAfter" alt="">
</ng-template>

<a
  *ngIf="url; else nativeButton"
  class="fi-button"
  [class]="hostClasses"
  [attr.href]="isDisabled ? null : url"
  [attr.target]="target || null"
  [attr.rel]="target === '_blank' ? 'noopener noreferrer' : null"
  [attr.aria-disabled]="isDisabled ? 'true' : null"
>
  <ng-container *ngTemplateOutlet="inner"></ng-container>
</a>

<ng-template #nativeButton>
  <button
    class="fi-button"
    [class]="hostClasses"
    [attr.type]="type"
    [disabled]="isDisabled"
  >
    <ng-container *ngTemplateOutlet="inner"></ng-container>
  </button>
</ng-template>
